/**
 *
 * @param {string} searchPhrase
 * @param {string} potentialMatch
 * @returns {boolean}
 */
function fuzzyMatch(searchPhrase, potentialMatch) {
  if (searchPhrase.length === 0) return false;
  if (searchPhrase.length === 1)
    return potentialMatch
      .toLowerCase()
      .includes(searchPhrase.toLocaleLowerCase());
  if (potentialMatch.includes(searchPhrase)) return true;

  // Helper to escape a single character
  const escapeChar = (char) => char.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

  // Split original searchPhrase into characters
  const chars = searchPhrase.split("");

  // Base pattern: allows optional chars between letters
  const basePattern = chars.map(escapeChar).join(".?");

  // Variants allowing one missing character
  const missingVariants = chars.map((_, i) => {
    const variant = chars.slice(0, i).concat(chars.slice(i + 1));
    return variant.map(escapeChar).join(".?");
  });

  // Variants allowing one transposition
  const transposedVariants = [];
  for (let i = 0; i < chars.length - 1; i++) {
    const variant = [...chars];
    const tmp = variant[i];
    variant[i] = variant[i + 1];
    variant[i + 1] = tmp;
    transposedVariants.push(variant.map(escapeChar).join(".?"));
  }

  // Combine everything
  const pattern = `.*(?:${[
    basePattern,
    ...missingVariants,
    ...transposedVariants,
  ].join("|")}).*`;

  const regex = new RegExp(pattern, "i"); // case-insensitive

  return regex.test(potentialMatch);
}

export default fuzzyMatch;
